<mat-form-field class="w-full" appearance="outline" subscriptSizing="dynamic">
  <input
    matInput #searchInput placeholder="Search..." (keyup)="onSearchTextChange(searchInput.value)"
    [matAutocomplete]="auto"
  >

  <div matPrefix class="px-3">
    <fa-icon [icon]="faSearch" />
  </div>

  @if (isLoading()) {
    <div class="px-3" matSuffix>
      <app-loading-indicator [diameter]="30" />
    </div>
  }

  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onArticleSelectedAsync($event.option.value, searchInput)">
    @for (article of filteredArticles(); track article.id) {
      <mat-option [value]="article">{{ article.title | multilang:language() }}</mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
